import React, { ReactNode, useEffect } from 'react';
import { StyleSheetManager } from 'styled-components';
import rtlPlugin from 'stylis-plugin-rtl';
import type { TextDirection } from '../../../shared-server/api/country-attributes/country-attributes';

const I18nManager = ({
  language,
  direction,
  children,
}: {
  language: string;
  direction: TextDirection;
  children: ReactNode;
}) => {
  /**
   * The dir and lang attributes get set in _document.tsx, but
   * this component is only used server-side to render the
   * initial markup. Since we can perform client-side navigation
   * to pages in other markets, we need to keep the attributes
   * up to date as the direction and language change.
   */
  useEffect(
    () => document.documentElement.setAttribute('dir', direction),
    [direction],
  );
  useEffect(
    () => document.documentElement.setAttribute('lang', language),
    [language],
  );

  const stylisPlugins = direction === 'rtl' ? [rtlPlugin] : [];

  return (
    <StyleSheetManager stylisPlugins={stylisPlugins}>
      <>{children}</>
    </StyleSheetManager>
  );
};

export default I18nManager;
